import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';

import { useContext } from 'react'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Autocomplete, Box, Button, CircularProgress, FormControl, Grid2, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { AuthContext } from '../../utils/AuthContext';
import { registerAgent } from '../../services/AuthService';
import { toast } from 'react-toastify';
import CheckIcon from '@mui/icons-material/Check';
import { resetPassword, updateAgent } from '../../services/UsersService';



function ResetPasswordDialog({ dialogOpen, setDialogOpen, callback, mode, userParam, selectedUser }) {

  const { auth } = useContext(AuthContext);



  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);


  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (selectedUser === null) {
      clearForm();
    } else {
      setEmail(selectedUser.email);
    }
  }, [selectedUser]);


  const dialogRef = useRef();


  useEffect(() => {

    if (dialogOpen) {
      setTimeout(() => {
        dialogRef.current.getElementsByClassName('MuiInputBase-input')[1].focus();
      }, 100)

      setPassword('');
      setConfirmPassword('');
      setPasswordError('');
      setConfirmPasswordError('');
    }

  }, [dialogOpen]);

  const handleClose = () => {
    setDialogOpen(false);
  };



  function clearForm() {
    setEmail('');
    setPassword('');
    setConfirmPassword('');
  }

  function displayErrors(data) {
    if (data.hasOwnProperty('errors')) {
      if (data.errors.hasOwnProperty('email')) {
        setEmailError(data.errors.email);
      }
    } else {
      return false;
    }


    return true;
  }


  function validate() {
    let isValid = true;

    const emailTrimmed = email.trim();
    const passwordTrimmed = password.trim();
    const confirmPasswordTrimmed = confirmPassword.trim();

    setEmailError('');
    setPasswordError('');
    setConfirmPasswordError('');


    if (emailTrimmed === '') {
      setEmailError('Email is required.');
      isValid = false;
    } else if (emailTrimmed.length > 50) {
      setEmailError('Email is too long.');
      isValid = false;
    }


    if (passwordTrimmed === '') {
      setPasswordError('Password is required.');
      isValid = false;
    } else if (passwordTrimmed.length <= 6) {
      setPasswordError('Password is weak.');
      isValid = false;
    } else if (passwordTrimmed.length > 20) {
      setPasswordError('Password is too long.');
      isValid = false;
    }

    if (confirmPasswordTrimmed === '') {
      setConfirmPasswordError('Confirm password is required.');
      isValid = false;
    } else if (confirmPasswordTrimmed !== passwordTrimmed) {
      setConfirmPasswordError('Password does not match.');
      isValid = false;
    }



    return isValid;
  }

  function handleSubmit() {
    const isValid = validate();

    if (!isValid) {
      return;
    }

    handleResetPassword();

  }

  function handleResetPassword() {
    setLoading(true);

    resetPassword({
      token: auth.token, userId: selectedUser.id, data: {
        password: password
      }
    }).then(() => {
      toast.success("Password has been updated.", {
        autoClose: 2000,
        hideProgressBar: true,
        icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
        closeButton: false
      });

      setLoading(false);
      setDialogOpen(false);
    }).catch(() => {
      toast.error("An error has occurred", {
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: false
      });

      setLoading(false);
    })
  }

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  return (
    <Dialog
      open={dialogOpen}
      onClose={handleClose}
      sx={{ zIndex: 9998 }}
      ref={dialogRef}
    >
      <DialogTitle sx={{ mt: 3 }}>
        Reset Password
      </DialogTitle>


      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: 12, color: '#616161' }}>EMAIL</Typography>
          <TextField
            size='small'
            margin="dense"
            type="email"
            fullWidth
            variant="outlined"
            value={email}
            onChange={(e) => { setEmail(e.target.value) }}
            error={emailError !== ''}
            helperText={emailError}
            disabled
          />
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: 12, color: '#616161' }}>PASSWORD</Typography>
          <OutlinedInput
            size='small'
            margin="dense"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => { setPassword(e.target.value) }}
            error={passwordError !== ''}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? 'hide the password' : 'display the password'}
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>

            }
          />
          <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{passwordError}</Typography>
        </Box>

        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: 12, color: '#616161' }}>CONFIRM PASSWORD</Typography>
          <OutlinedInput
            size='small'
            margin="dense"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => { setConfirmPassword(e.target.value) }}
            error={confirmPasswordError !== ''}
            helperText={confirmPasswordError}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? 'hide the password' : 'display the password'}
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>

            }
          />

          <Typography sx={{ ml: 2, fontSize: 13, color: '#d32f2f', mt: 0.5 }}>{confirmPasswordError}</Typography>
        </Box>

      </DialogContent>
      <DialogActions sx={{ mb: 3, px: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            disabled={isLoading}
            variant='contained'
            onClick={handleSubmit}>Reset</Button>
          {
            isLoading &&
            <CircularProgress size={24} sx={{ ml: 2 }} />
          }
        </Box>
      </DialogActions>

    </Dialog>
  )
}

export default ResetPasswordDialog

